import { h, Component } from 'preact';
import Portal from 'preact-portal';
import style from './style';
import root from '@components/root';

class Dialog extends Component {
  open = () => {
    if (!this.element) {
      return root.setTimeout(this.open, 32);
    }
    this.checkElements();

    // Disable scroll on body
    if (document !== void 0) document.body.setAttribute('modal-visible', true);
  };
  checkElements = () => {
    const contains = this.element.contains(document.activeElement);
    // Save all elements that we can focus on
    this.focusableElements = this.element.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );

    // When the dialog is closed, focus should be returned to the element that opened it
    if (document && document.activeElement && !contains)
      this.lastFocusedElement = document.activeElement;
    // When first opened, focus should be set to the first focusable element within the dialog
    this.firstFocusableElement = this.focusableElements.length
      ? this.focusableElements[0]
      : null;
    this.lastFocusableElement = this.focusableElements.length
      ? this.focusableElements[this.focusableElements.length - 1]
      : null;

    if (this.firstFocusableElement !== null && !contains)
      root.setTimeout(() => this.firstFocusableElement.focus(), 0);
  };
  close = () => {
    // When the dialog is closed, focus should be returned to the element that opened it
    if (this.lastFocusedElement) this.lastFocusedElement.focus();

    // Enable scroll on body
    if (document !== void 0) document.body.removeAttribute('modal-visible');
  };
  onKeyDown = e => {
    const KEY_TAB = 9,
      KEY_ESC = 27;
    switch (e.keyCode) {
      case KEY_TAB:
        if (this.focusableElements.length === 1) {
          e.preventDefault();
          break;
        }
        if (e.shiftKey) {
          this._handleBackwardTab(e);
        } else {
          this._handleForwardTab(e);
        }
        break;
      case KEY_ESC:
        this.props.close ? this.props.close() : null;
        break;
      default:
        break;
    }
  };
  _handleBackwardTab = e => {
    if (document && document.activeElement === this.firstFocusableElement) {
      e.preventDefault();
      this.lastFocusableElement.focus();
    }
  };
  _handleForwardTab = e => {
    if (document && document.activeElement === this.lastFocusableElement) {
      e.preventDefault();
      this.firstFocusableElement.focus();
    }
  };
  componentDidMount() {
    if (this.props.show) this.open();
    window.setTimeout(this.checkHeight, 32);
  }
  checkHeight = () => {
    const shouldScroll =
      this.dialog && this.dialog.scrollHeight > window.innerHeight;

    if (!this.state.scroll && shouldScroll) {
      this.setState({ scroll: true });
    } else if (this.state.scroll && !shouldScroll) {
      this.setState({ scroll: false });
    }
  };
  componentWillReceiveProps({ show }) {
    if (show && show !== this.props.show) this.open();
    else if (!show && show !== this.props.show) this.close();
    window.setTimeout(this.checkHeight, 32);
    window.setTimeout(this.checkHeight, 100);
  }
  componentWillUnmount() {
    this.close();
  }
  render(props, state) {
    return props.show ? (
      <Portal into="body">
        <div
          class={style.dialogContainer}
          aria-hidden={props.show ? false : true}
          ref={el => (this.element = el)}
        >
          <dialog
            ref={el => (this.dialog = el)}
            class={`${style.dialog} ${props.class} ${
              state.scroll ? style.scroll : ''
            }`.trim()}
            aria-labelledby={props.title ? 'dialog-title' : null}
            onKeyDown={this.onKeyDown}
            style={props.style}
          >
            {props.title ? (
              <h1 id="dialog-title" class={style.title}>
                {props.title}
              </h1>
            ) : null}
            {props.children}
            <button
              class={style.closeButton}
              type="button"
              data-a11y-dialog-hide
              aria-label="Close this dialog window"
              onClick={props.close}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
              </svg>
            </button>
          </dialog>
          <div
            class={style.overlay}
            tabindex="-1"
            data-a11y-dialog-hide
            onClick={this.props.close}
          />
        </div>
      </Portal>
    ) : null;
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./components/modal/index.js